import _ from 'lodash';
import chartColors from '../../../shared/js/lib/chartColors';
import DashboardNavigation from '../components/DashboardNavigation';
import React, { PropTypes } from 'react';
import { Bar, Doughnut, HorizontalBar } from 'react-chartjs-2';
import 'chartjs-plugin-datalabels';
import dashboardCharts from '../lib/dashboardCharts';

let DashboardTeacherDetails = React.createClass({
	propTypes: {
		observation: PropTypes.object.isRequired,
		router: PropTypes.object.isRequired,
		teacherEventTypes: PropTypes.array
	},

	getTeacherObservations: function() {
		return this.props.observation.teacher_observations;
	},

	getInstructionTypeDuration: function(management, instructionType) {
		let duration = 0;

		this.props.observation.teacher_observations.map((teacherObservation) => {
			if (
				teacherObservation.observation_management.description === management &&
				teacherObservation.observation_instruction_type.abbreviation === instructionType
			) {
				duration += dashboardCharts.getDuration(teacherObservation);
			}
		});

		return duration;
	},

	getOffTaskDuration: function(management, instructionType) {
		let duration = 0;

		this.props.observation.teacher_observations.map((teacherObservation) => {
			if (
				teacherObservation.observation_management.description === management &&
				teacherObservation.observation_instruction_type.abbreviation === instructionType &&
				teacherObservation.teacher_behavior_type.description === 'Off task'
			) {
				duration += dashboardCharts.getDuration(teacherObservation);
			}
		});

		return duration;
	},

	render: function() {
		return (
			<div className="observation-overview">
				<div className="row observation-dashboard-header">
					<div className="col-lg-8">
						<h2>
							Teacher Details: { this.props.observation.teacher.first_name + ' ' + this.props.observation.teacher.last_name }
						</h2>
					</div>
					<div className="col-lg-4">
						<DashboardNavigation observation={ this.props.observation } router={ this.props.router } />
					</div>
				</div>

				<div className="row">
					<div className="col-lg-3" />
					<div className="col-lg-6">
						<div className="dashboard-card chart-card">
							<h3>Content</h3>
							<p>Minutes Observed</p>
							<div className="chart-container">
								<Doughnut
									data={ dashboardCharts.getDoughnutChartData(this.getTeacherObservations(this.props.observation.teacher.id), 'observation_subject') }
									options={ dashboardCharts.getDoughnutChartOptions() }
								/>
							</div>
						</div>
					</div>
					<div className="col-lg-3" />
				</div>
				<div className="row">
					<div className="col-lg-4">
						<div className="dashboard-card chart-card">
							<h3>Literacy</h3>
							<p>Minutes Observed</p>
							<div className="chart-container">
								<HorizontalBar
									data={ dashboardCharts.getLiteracyBreakdownChartData(this.getTeacherObservations()) }
									options={ dashboardCharts.getBarChartOptions(this.props.observation.teacher_minutes * this.props.observation.number_of_cycles) }
								/>
							</div>
						</div>
					</div>
					<div className="col-lg-4">
						<div className="dashboard-card chart-card">
							<h3>Math</h3>
							<p>Minutes Observed</p>
							<div className="chart-container">
								<HorizontalBar
									data={ dashboardCharts.getMathBreakdownChartData(this.getTeacherObservations()) }
									options={ dashboardCharts.getBarChartOptions(this.props.observation.teacher_minutes * this.props.observation.number_of_cycles) }
								/>
							</div>
						</div>
					</div>
					<div className="col-lg-4">
						<div className="dashboard-card chart-card">
							<h3>Other</h3>
							<p>Minutes Observed</p>
							<div className="chart-container">
								<HorizontalBar
									data={ dashboardCharts.getOtherBreakdownChartData(this.getTeacherObservations()) }
									options={ dashboardCharts.getBarChartOptions(this.props.observation.teacher_minutes * this.props.observation.number_of_cycles) }
								/>
							</div>
						</div>
					</div>
				</div>

				<div className="row">
					<div className="col-lg-2" />
					<div className="col-lg-8">
						<div className="dashboard-card chart-card">
							<h3>Teacher Moves</h3>
							<p>Observed Occurrences</p>
							<div className="chart-container" style={ { height: '700px' } }>
								<HorizontalBar
									data={ dashboardCharts.getTeacherMovesChartData(this.props.teacherEventTypes, this.getTeacherObservations()) }
									options={ dashboardCharts.getMovesChartOptions() }
								/>
							</div>
						</div>
					</div>
					<div className="col-lg-2" />
				</div>
			</div>
		);
	}
});

module.exports = DashboardTeacherDetails;



// WEBPACK FOOTER //
// ./frontend/olos/js/components/DashboardTeacherDetails.jsx